interface ChuvaToggleButtonProps {
  active: boolean;
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

const ChuvaToggleButton = ({
  active,
  icon,
  label,
  onClick,
}: ChuvaToggleButtonProps) => (
  <button
    type="button"
    className={`rv-chuva-toggle${active ? ' rv-chuva-toggle--active' : ''}`}
    onClick={onClick}
  >
    {icon}
    {label}
  </button>
);

export default ChuvaToggleButton;
